import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { FooterButton } from '../FooterButton/FooterButton';
import { PRIVACY_POLICY_URL } from '../PayButton/PayButton';
import { AppchargeIcon } from '../../../../../../assets/icons';
import { useAppConfig } from '../../../../../../hooks/use-app-config';
import { useCheckout } from '../../../../../../hooks/use-checkout';
import { generateZendeskSupportURL } from './support-url.utils';
import { getIsSupercellTemplate } from '../../../../../../utils/get-is-supercell-template';

interface FormFooterProps {
  isHiddenApmsShown: boolean;
}

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

export function FormFooter({ isHiddenApmsShown }: FormFooterProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { publisherId, publisherData } = useAppConfig();

  const { checkoutData } = useCheckout();

  const supportURL = generateZendeskSupportURL({
    checkoutData,
    publisherId,
    publisherData,
  });

  return (
    <Box className={`form-footer ${isHiddenApmsShown ? 'minimize' : ''}`} fontSize={10} pt={2}>
      <Stack direction="column" alignItems="center" spacing={1.5}>
        <Box display="flex" alignItems={'center'}>
          <Box pr={1}>{t('poweredBy')}</Box> <AppchargeIcon />
        </Box>
        <Stack direction="row" spacing={1} divider={<hr style={{ width: 'auto' }} />}>
          <FooterButton url={PRIVACY_POLICY_URL} text={t('privacyPolicy')} />
          <FooterButton url={'https://appcharge.com/refund-policy/'} text={t('refundPolicy')} />
          {!IS_SUPERCELL_TEMPLATE && <FooterButton url={supportURL} text={t('support')} />}
        </Stack>
      </Stack>
    </Box>
  );
}
